module.exports = __webpack_public_path__ + "media/images/icons/outlined/google-5c70a485e06beed5fdc687ecb0ec8361.svg";